<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-hover" style="background-color: white;">
      <thead style="background-color: #a0b49b;">
        <tr>
          <th>Identificación (CUI)</th>
          <th>Nombre de Empleado</th>
          <th>Inicio de Beneficio</th>
          <th>Fin de Beneficio</th>
          <th>Tipo Empleado</th>
          <th>lista Precio</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="current in dataTabla.results" v-bind:key="current.id" @click="
          rowClick('cat-cupones-apl-editar', {
            id: current.id,
          })
          ">
          <td>{{ current.id }}</td>
          <td>{{ current.nombre }}</td>
          <td>{{ current.fecha_inicio | moment("YYYY-MM-DD hh:mm") }}</td>
          <td>{{ current.fecha_fin | moment("YYYY-MM-DD hh:mm") }}</td>
          <td><span v-if="current.tipo_oferta == 'I'">INTERNO</span>
            <span v-if="current.tipo_oferta == 'E'">EXTERNO</span>
          </td>
          <td>{{ current.lista_precio_obj.id }} - {{ current.lista_precio_obj.nombre }}</td>
          <td>
            <i :class="{
              'fas fa-angle-up': isFutureDate(current.fecha_fin),
              'fas fa-angle-down': !isFutureDate(current.fecha_fin)
            }" :style="{
              color: isFutureDate(current.fecha_fin) ? 'green' : 'red'
            }">
            </i>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
  </div>
  

</template>

<script>
import moment from 'moment';
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components:{
    PaginationComponent,
  },
    data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  props: ["dataTabla"],
  mounted() { },
  methods: {
    rowClick(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: name,
          params: params,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: name,
          params: params,
        });
      }
    },
    isFutureDate(fecha) {
      const fechaFormateada = moment(fecha, 'DD/MM/YYYY', true);
      if (!fechaFormateada.isValid()) {
        return false;
      }
      return fechaFormateada.isAfter(moment(), 'day');
    },
  },
};
</script>
